import { useMemo } from 'react'
import { DEFAULT_SCHOOL_FEATURES, normalizeSchoolFeatures } from '../constants/features.js'
import { useAuth } from './useAuth.js'

export const useSchoolFeatures = () => {
  const { user, schoolConfig } = useAuth()

  return useMemo(() => {
    if (user?.role === 'super_admin') return DEFAULT_SCHOOL_FEATURES
    return normalizeSchoolFeatures(schoolConfig?.features)
  }, [schoolConfig?.features, user?.role])
}

export const useFeatureEnabled = (feature) => {
  const features = useSchoolFeatures()
  return Boolean(features[feature])
}
